/**
 * 업로드 전 클라이언트 리사이즈·JPEG 재인코딩 (설계 §2 자율 결정).
 *
 * Cloud Function(`imageUpdateV2`)이 `image/jpeg` 를 하드코딩해 처리하므로, 원본 형식과 무관하게
 * 항상 JPEG 로 재인코딩해서 보낸다 — 모바일 리사이즈 상수(장변 1200px)와 톤을 맞춘다.
 *
 * 🚨 브라우저 canvas API 에 의존해 jsdom 등 테스트 환경에서 실행할 수 없다 — 이 모듈 자체는
 * 단위테스트 대상이 아니고, 호출부(`venueImageUploadApi.ts`)가 이 함수를 모킹해서 검증한다.
 */

export const IMAGE_RESIZE_MAX_DIMENSION = 1200
export const IMAGE_RESIZE_JPEG_QUALITY = 0.8

export async function resizeImageToJpeg(
  file: File,
  maxDimension: number = IMAGE_RESIZE_MAX_DIMENSION,
  quality: number = IMAGE_RESIZE_JPEG_QUALITY
): Promise<Blob> {
  const bitmap = await createImageBitmap(file)
  try {
    const scale = Math.min(1, maxDimension / Math.max(bitmap.width, bitmap.height))
    const width = Math.max(1, Math.round(bitmap.width * scale))
    const height = Math.max(1, Math.round(bitmap.height * scale))

    const canvas = document.createElement('canvas')
    canvas.width = width
    canvas.height = height
    const ctx = canvas.getContext('2d')
    if (!ctx) throw new Error('이미지를 처리할 수 없습니다.')
    ctx.drawImage(bitmap, 0, 0, width, height)

    return await new Promise<Blob>((resolve, reject) => {
      canvas.toBlob(
        (blob) => {
          if (blob) resolve(blob)
          else reject(new Error('이미지를 처리할 수 없습니다.'))
        },
        'image/jpeg',
        quality
      )
    })
  } finally {
    bitmap.close()
  }
}
